module.exports = __webpack_public_path__ + "img/DE02545.385ada7a.png";